import { i18n } from "../translate/i18n";

const META_RATE_LIMIT_MESSAGE = "Too Many Requests";

/**
 * Extract stable backend error code from axios error or plain string.
 */
export function resolveBackendErrorCode(source) {
  if (!source) return null;
  if (typeof source === "string") return source;
  const data = source.response?.data;
  if (!data) return null;
  if (typeof data === "string") return data;
  const code = data.error || data.message;
  return typeof code === "string" ? code : null;
}

function resolveMetaGraphMessage(source) {
  const data = source?.response?.data;
  if (!data || typeof data !== "object") return null;
  const candidates = [
    data.metaGraphMessage,
    data.errorUserMsg,
    data.graphMessage,
  ];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return null;
}

/**
 * Translate backend error code to operator-facing copy.
 * Falls back to raw code when no i18n key exists.
 */
export function translateBackendError(source) {
  const metaGraphMessage = resolveMetaGraphMessage(source);
  if (metaGraphMessage) {
    return metaGraphMessage;
  }

  const code = resolveBackendErrorCode(source);
  if (!code) return null;

  if (code === META_RATE_LIMIT_MESSAGE) {
    return i18n.t("backendErrors.rate_limited");
  }

  const key = `backendErrors.${code}`;
  return i18n.exists(key) ? i18n.t(key) : code;
}
